import { withLayout } from 'pages/GuestLayout';

import LoginPage from './LoginPage';

export default withLayout('Login', LoginPage);
